import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { CookieConsentManager } from './components/CookieConsent'
import { createPosthogClient } from './lib/posthog'
import { PostHogProvider } from '@posthog/react'
import PrivacyPolicy from './pages/PrivacyPolicy.tsx'
import TermsOfService from './pages/TermsOfService.tsx'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import type { PropsWithChildren } from 'react'

const posthogClient = createPosthogClient()

const AppProviders = ({ children }: PropsWithChildren) =>
  posthogClient ? (
    <PostHogProvider client={posthogClient}>
      {children}
      <CookieConsentManager />
    </PostHogProvider>
  ) : (
    <>
      {children}
      <CookieConsentManager />
    </>
  )

const router = createBrowserRouter([
  { path: '/', element: <App /> },
  { path: '/home', element: <App /> },
  { path: '/privacy', element: <PrivacyPolicy /> },
  { path: '/terms', element: <TermsOfService /> },
])

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
)
